import React, { useContext, useEffect, useState } from "react";
import { WebSiteConfig, TokenLocalStorageKey, NotAuthPages } from "base/Constant";
import AuthViewModel from "../../viewModel";
import { useNavigate, useSearchParams } from "react-router-dom";
import { HOME, LOGIN } from "constants/path";
import ToastMsg from "components/Toast";
import UserModel from "models/userModel";

function usePermission() {
	const [searchParams] = useSearchParams();

	const navigate = useNavigate();
	const userModel = useContext(UserModel.Context);
	const { isLoading, setIsLoading } = useContext(AuthViewModel.Context);
	const [message, setMessage] = useState("");
	const [isLogin, setIsLogin] = useState("");

	async function getPermission() {
		setIsLoading(true);
		const login = await userModel.getMe();
		setIsLoading(false);
		setIsLogin(login);
		if (login) {
			navigate(HOME);
		}
	}

	useEffect(() => {
		const query = Object.fromEntries([...searchParams]);
		const { accessToken, expiresIn, hasPermission } = query;
		setMessage("");
		if (accessToken) {
			window.localStorage.setItem(TokenLocalStorageKey, accessToken);
			getPermission();
		} else {
			setMessage("Access Denied. Please try again.");
		}
	}, [searchParams]);

	useEffect(() => {
		if (!isLogin) {
			getPermission();
		}
	}, [isLogin]);

	return {
		isLoading,
		navigate,
		message,
	}
}

export default usePermission;
